'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function reduceBindingsObj(bindingsObj) {
  const keys = Object.keys(bindingsObj);
  return keys.reduce((acc, key) => {
    const bindsTo = bindingsObj[key];
    if (typeof bindsTo === "function") {
      const bindsToResult = bindsTo();
      if (!bindsToResult) {
        return acc;
      }
      if (acc === "") {
        return `${key}`;
      }
      return `${acc} ${key}`;
    }
    if (bindingsObj[key]) {
      if (acc === "") {
        return key;
      }
      return `${acc} ${key}`;
    }
    return acc;
  }, "");
}
function partsBinder(prefix, bindings) {
  if (!bindings) {
    return prefix;
  }
  let _bindings = bindings;
  let _prefix = "";
  if (typeof prefix === "object") {
    _bindings = prefix;
  }
  if (typeof prefix === "string") {
    _prefix = prefix;
  }
  if (typeof _bindings === "string") {
    return `${_prefix} ${_bindings}`;
  }
  if (Array.isArray(_bindings)) {
    const parts = _bindings.map((value) => {
      if (typeof value === "string") {
        return value;
      }
      if (typeof value === "object") {
        return reduceBindingsObj(value);
      }
      return "";
    });
    const result = [_prefix];
    return result.concat(parts).join(" ");
  }
  const suffix = reduceBindingsObj(_bindings);
  return `${_prefix}${suffix === "" ? "" : " " + suffix}`;
}

exports.partsBinder = partsBinder;
